import { InfoHeaderModule } from './../../../widgets/info-header/info-header.module';
import { DxDataGridModule, DxTextBoxModule, DxButtonModule, DxPopupModule, DxLoadPanelModule, DxChartModule, DxRangeSelectorModule, DxSwitchModule } from 'devextreme-angular';
import { DropDownFilterModule } from './../../../widgets/dropdown-filter/dropdown-filter.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActivityResultRoutingModule } from './activity-result-routing.module';
import { ActivityResultComponent } from './activity-result.component';
import { DxoValueAxisModule } from 'devextreme-angular/ui/nested';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';


@NgModule({
  declarations: [ActivityResultComponent],
  imports: [
    CommonModule,
		ActivityResultRoutingModule,
		DropDownFilterModule,
		DxDataGridModule,
		DxTextBoxModule,
		DxButtonModule,
		InfoHeaderModule,
		DxPopupModule,
		DxLoadPanelModule,
		DxChartModule,
		DxoValueAxisModule,
		DxRangeSelectorModule,
		BookmarkModule,
		DxSwitchModule,
		ContainerComponent,
		DxTableControllerDirective,
		HelpButtonComponent,FiltersGroupModule,BookmarkNewComponent,
  ]
})
export class ActivityResultModule { }
